// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../../../hola/pub/settings_ctx';
import cn from 'classnames';
import Need_help_img from '../../../toolip/pub/img/products/need_help.svg';
import styles from './need_help_card.module.less';
import {Button} from '../../../hola/pub/lib/button';
import {use_qs} from '../../../hola/pub/lib/use_qs';

export const Need_help_card = ()=>{
  const {theme} = useContext(Settings_context);
  const qs = use_qs();
  const ui_for_user = !qs.debug_ui;
  return <div className={styles.need_help}>
    <Need_help_img className={styles.img}/>
    <div className={styles.text}>
      <p className={cn(theme.p16, theme.color_n700, theme.med)}>
        Need help finding the right proxy package for you?</p>
      <Button
        size="sm"
        cls={cn(ui_for_user ? theme.p16 : theme.p14,
          theme.reg, theme.color_n700, styles.btn)}
        color={'transparent_black'}
        round={false}
        as_external={true}
        to={'mailto:support@toolip.io'}
        caption={'Get in touch!'}
      />
    </div>
  </div>;
};
